import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper/index';
import './styles.css';
import EstimateLink from "../../components/estimate-link";
import ModalWindow from "../../components/modal-window";
import BodyControl from "../../components/body";
import {convertPipeToBrTag} from "../../utils";
import {getComponents} from "../utilities";

/**
 *  BodySize
 */
class CreditPlan extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    anchorPoint: PropTypes.string,
    anchorName: PropTypes.string,
    titleAndDescription: PropTypes.string,
    mbTitleAndDescription: PropTypes.string,
    hideBodyTypeModelName: PropTypes.bool,
    hideGradeDriveAndMission: PropTypes.bool,
    hideEngineName: PropTypes.bool,
    hidePrice: PropTypes.bool,
    images: PropTypes.array,
    mbImages: PropTypes.array,
    titleHeader: PropTypes.string,
    estimationTitle: PropTypes.string,
    mbEstimationTitle: PropTypes.string,
    estimationLinkLabel: PropTypes.string,
    lowerInformation: PropTypes.string,
    tableColorSelector: PropTypes.string,
    modelName: PropTypes.string,
    bodyType: PropTypes.shape({
      carId: PropTypes.string,
      bodyTypeModel: PropTypes.string,
      carType: PropTypes.shape({
        carTypeCode: PropTypes.string,
        grade: PropTypes.shape({
          gradeId: PropTypes.string,
          gradeCode: PropTypes.string,
          gradeName: PropTypes.string,
          specialCar: PropTypes.bool,
          engine: PropTypes.shape({
            fuel: PropTypes.string,
          }),
          variant: PropTypes.shape({
            transmission: PropTypes.string,
            drive: PropTypes.string,
            engine: PropTypes.string,
            price: PropTypes.number,
            vehicleCreditData: PropTypes.arrayOf(PropTypes.shape({
              planName: PropTypes.string,
              mbPlanName: PropTypes.string,
              description: PropTypes.string,
              moreInfoLink: PropTypes.string,
              moreInfo: PropTypes.array,
              largeItems: PropTypes.arrayOf(PropTypes.shape({
                title: PropTypes.string,
                data: PropTypes.string,
              })),
              smallItems: PropTypes.arrayOf(PropTypes.shape({
                title: PropTypes.string,
                data: PropTypes.string
              }))
            }))
          })
        })
      })
    })
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    anchorPoint: null,
    anchorName: null,
    titleAndDescription: null,
    mbTitleAndDescription: null,
    hideBodyTypeModelName: null,
    hideGradeDriveAndMission: null,
    hideEngineName: null,
    hidePrice: null,
    images: null,
    mbImages: null,
    titleHeader: null,
    estimationTitle: null,
    mbEstimationTitle: null,
    estimationLinkLabel: null,
    lowerInformation: null,
    tableColorSelector: null,
    modelName: null,
    bodyType: null,
  };
  
  constructor(props) {
    super();
    this.props = props;
    this.state = {};
    this.modalWindowRefs = [];
  }
  
  componentDidMount() {
  };
  
  componentWillUnmount() {
  }
  
  render() {
  
    this.modalWindowRefs = [];
  
    // ヘッダー表示
    const renderHeader = ()=> {

      const getHeader = () => {
        if (this.props.titleAndDescription && this.props.titleAndDescription !== '') {
          return this.props.titleAndDescription;
        } else {
          return '';
        }
      };
      const getMbHeader = () => {
        if (this.props.mbTitleAndDescription && this.props.mbTitleAndDescription !== '') {
          return this.props.mbTitleAndDescription;
        } else {
          return getHeader();
        }
      };

      return (
         <div className="CreditPlan__header Wysiwyg">
           <div className="CreditPlan__header-pc" dangerouslySetInnerHTML={{__html: getHeader()}}/>
           <div className="CreditPlan__header-mb" dangerouslySetInnerHTML={{__html: getMbHeader()}}/>
         </div>
       )
    };
    
    // 車種情報表示
    const renderCarInfo = ()=> {
  
      const getImages = ()=> {
        if (this.props.images && this.props.images instanceof Array && 1 <= this.props.images.length) {
          return this.props.images;
        } else {
          return null;
        }
      };
      const getMbImages = ()=> {
        if (this.props.mbImages && this.props.mbImages instanceof Array && 1 <= this.props.mbImages.length) {
          return this.props.mbImages;
        } else {
          return getImages();
        }
      };
  
      // BodyType表示
      const renderBodyType = ()=> {
        if (this.props.hideBodyTypeModelName === true) return null;
        //
        if (this.props.bodyType.bodyTypeModel && this.props.bodyType.bodyTypeModel !== '') {
          return (
            <h4 className="CreditPlan__car-info__body-type">{this.props.bodyType.bodyTypeModel}</h4>
          )
        } else {
          return null;
        }
      };
      
      // Grade表示
      const renderGrade = ()=> {
        //
        const getGradeName = ()=> {
          const gradeInfo = this.props.bodyType.carType.grade;
          if (gradeInfo.specialCar === true) {
            return gradeInfo.gradeId;
          } else {
            if (gradeInfo.gradeName && gradeInfo.gradeName !== '') {
              return gradeInfo.gradeName;
            } else {
              return gradeInfo.gradeId;
            }
          }
        };
        //
        if (this.props.hideGradeDriveAndMission === true) return null;
        //
        if (this.props.bodyType.carType) {
          if (this.props.bodyType.carType.grade) {
            if (this.props.bodyType.carType.grade.gradeId && this.props.bodyType.carType.grade.gradeId !== '') {
              if (this.props.bodyType.carType.grade.variant) {
                if (this.props.bodyType.carType.grade.variant.drive && this.props.bodyType.carType.grade.variant.drive !== '' && this.props.bodyType.carType.grade.variant.transmission && this.props.bodyType.carType.grade.variant.transmission !== '') {
                  return (
                    <span className="CreditPlan__car-info__grade">{getGradeName() + '(' + this.props.bodyType.carType.grade.variant.drive + ' ' + this.props.bodyType.carType.grade.variant.transmission + ')'}</span>
                    // <span className="CreditPlan__car-info__grade">{((this.props.bodyType.carType.grade.gradeName && this.props.bodyType.carType.grade.gradeName !== '') ? this.props.bodyType.carType.grade.gradeName : this.props.bodyType.carType.grade.gradeId) + '(' + this.props.bodyType.carType.grade.variant.drive + ' ' + this.props.bodyType.carType.grade.variant.transmission + ')'}</span>
                  )
                }
              }
            }
          }
        }
        return null;
      };
      
      // Engine表示
      const renderEngine = ()=> {
        if (this.props.hideEngineName === true) return null;
        //
        if (this.props.bodyType.carType) {
          if (this.props.bodyType.carType.grade) {
            if (this.props.bodyType.carType.grade.engine) {
              if (this.props.bodyType.carType.grade.engine.fuel && this.props.bodyType.carType.grade.engine.fuel !== '') {
                return (
                  <span className="CreditPlan__car-info__engine">{this.props.bodyType.carType.grade.engine.fuel}</span>
                )
              }
            }
          }
        }
        return null;
      };
      // const renderEngine = ()=> {
      //   if (this.props.hideEngineName === true) return null;
      //   //
      //   if (this.props.bodyType.carType) {
      //     if (this.props.bodyType.carType.grade) {
      //       if (this.props.bodyType.carType.grade.variant) {
      //         if (this.props.bodyType.carType.grade.variant.engine && this.props.bodyType.carType.grade.variant.engine !== '') {
      //           return (
      //             <span className="CreditPlan__car-info__engine">{this.props.bodyType.carType.grade.variant.engine}</span>
      //           )
      //         }
      //       }
      //     }
      //   }
      //   return null;
      // };
      
      // Price表示
      const renderPrice = ()=> {
        if (this.props.hidePrice === true) return null;
        //
        if (this.props.bodyType.carType) {
          if (this.props.bodyType.carType.grade) {
            if (this.props.bodyType.carType.grade.variant) {
              if (this.props.bodyType.carType.grade.variant.price && this.props.bodyType.carType.grade.variant.price !== '') {
                return (
                  <p className="CreditPlan__car-info__price">車両本体価格（消費税込）{this.formatPrice(this.props.bodyType.carType.grade.variant.price)}</p>
                )
              }
            }
          }
        }
        return null;
      };
  
      if (this.props.bodyType) {
        return (
          <div className="CreditPlan__car-info">
            
            {renderBodyType()}
            
            <div className="CreditPlan__car-info__box">
              
              <p className="CreditPlan__car-info__paragraph">
                
                {renderGrade()}
                
                {renderEngine()}
                
              </p>
              
              {renderPrice()}

            </div>
            
            {(getImages()) ?
              <div className="CreditPlan__car-info__images-pc">
                {getImages()}
              </div>
              : null}

            {(getMbImages()) ?
              <div className="CreditPlan__car-info__images-mb">
                {getMbImages()}
              </div>
              : null}

          </div>
        )
      } else {
        return null;
      }
    };
    
    // クレジット情報表示
    const renderCreditData = ()=> {
      
      // 各クレジット情報表示
      const renderCreditDataInfo = (vehicleCreditData, index)=> {
        
        // クレジットタイトル表示
        const renderCreditDataHeading = ()=> {
          
          const getPlanName = ()=> {
            if (vehicleCreditData.planName && vehicleCreditData.planName !== '') {
              return vehicleCreditData.planName;
            } else {
              return null;
            }
          };
          
          const getMbPlanName = ()=> {
            if (vehicleCreditData.mbPlanName && vehicleCreditData.mbPlanName !== '') {
              return vehicleCreditData.mbPlanName;
            } else {
              return getPlanName();
            }
          };
          
          const planName = getPlanName();
          const mbPlanName = getMbPlanName();
          if (this.props.titleHeader && this.props.titleHeader !== '' && planName) {
            return (
              <h5 className="CreditPlan__credit-data__heading">
                {this.props.titleHeader}
                <span className="CreditPlan__credit-data__heading-pc" dangerouslySetInnerHTML={{__html: convertPipeToBrTag(planName)}}/>
                <span className="CreditPlan__credit-data__heading-mb" dangerouslySetInnerHTML={{__html: convertPipeToBrTag(mbPlanName)}}/>
              </h5>
            )
          }
        };
        
        // 上部クレジット情報表示
        const renderLargeItems = ()=> {
          if (vehicleCreditData.largeItems && vehicleCreditData.largeItems instanceof Array && 1 <= vehicleCreditData.largeItems.length) {
            return (
              <div className="CreditPlan__credit-data__large-item">
                <div className="CreditPlan__credit-data__large-item__items">
                  {vehicleCreditData.largeItems.map((largeItems, index)=> {
                    if (index < 3) {
                      return (
                        <dl className="CreditPlan__credit-data__large-item__item" key={index}>
                          <dt>{(largeItems.title) ? largeItems.title : ''}</dt>
                          <dd>{(largeItems.data) ? largeItems.data : ''}</dd>
                        </dl>
                      )
                    } else {
                      return null;
                    }
                  })}
                </div>
              </div>
            )
          } else {
            return null;
          }
        };
        
        // 下部クレジット情報表示
        const renderSmallItems = ()=> {
          
          const renderSmallItem = (smallItem, index)=> {
            return (
              <dl className="CreditPlan__credit-data__small-item__item" key={index}>
                <dt>{(smallItem.title) ? smallItem.title : ''}</dt>
                <dd>{(smallItem.data) ? smallItem.data : ''}</dd>
              </dl>
            )
          };
          
          if (vehicleCreditData.smallItems && vehicleCreditData.smallItems instanceof Array && 1 <= vehicleCreditData.smallItems.length) {
            
            let length =  vehicleCreditData.smallItems.length;
            if (10 < length) length = 10;
            
            return (
              <div className="CreditPlan__credit-data__small-item">
                <div className="CreditPlan__credit-data__small-item__items">
                  {vehicleCreditData.smallItems.map((smallItem, index)=> {
                    if (index < 10) {
                      if (index + 1 <= Math.ceil(length / 2)) {
                        return (
                          renderSmallItem(smallItem, index)
                        )
                      } else {
                        return null;
                      }
                    } else {
                      return null;
                    }
                  })}
                </div>
                <div className="CreditPlan__credit-data__small-item__items">
                  {vehicleCreditData.smallItems.map((smallItem, index)=> {
                    if (index < 10) {
                      if (Math.ceil(length / 2) < index + 1) {
                        return (
                          renderSmallItem(smallItem, index)
                        )
                      } else {
                        return null;
                      }
                    } else {
                      return null;
                    }
                  })}
                </div>
              </div>
            )
          } else {
            return null;
          }
        };
        
        // 注釈表示
        const renderNote = ()=> {
          
          const renderDescription = ()=> {
            if (vehicleCreditData.description && vehicleCreditData.description !== '') {
              return (
                <div className="CreditPlan__credit-data__note__description Wysiwyg">
                  <div dangerouslySetInnerHTML={{__html: vehicleCreditData.description}}/>
                </div>
              )
            } else {
              return null;
            }
          };
          
          const renderMoreInfo = ()=> {
            if (vehicleCreditData.moreInfo && vehicleCreditData.moreInfo !== '') {
              const ref = 'modalWindow' + index;
              this.modalWindowRefs.push(ref);
              return (
                <div className="CreditPlan__credit-data__note__more-info">
                  <a className="CreditPlan__credit-data__note__more-info__link"
                     href="javascript:void(0);"
                     onClick={(e)=> {
                       e.preventDefault();
                       this.openModal(ref);
                     }}
                  >{(vehicleCreditData.moreInfoLink) ? vehicleCreditData.moreInfoLink : ''}</a>
                  <ModalWindow ref={ref} type="Light" onClose={this.onCloseModal}>
                    <div className="CreditPlan__credit-data__note__more-info__container">
                      {(vehicleCreditData.moreInfo && vehicleCreditData.moreInfo instanceof Array && 1 <= vehicleCreditData.moreInfo.length) ? getComponents(vehicleCreditData.moreInfo) : null}
                    </div>
                    {/*<div className="Wysiwyg">*/}
                      {/*<div dangerouslySetInnerHTML={{__html: vehicleCreditData.moreInfo}}/>*/}
                    {/*</div>*/}
                  </ModalWindow>
                </div>
              )
            } else {
              return null;
            }
          };
          
          return (
            <div className="CreditPlan__credit-data__note">
              {renderDescription()}
              {renderMoreInfo()}
            </div>
          )
          
        };
        
        return (
          <section className="CreditPlan__credit-data" key={index}>
  
            {renderCreditDataHeading()}
            
            {renderLargeItems()}
            
            {renderSmallItems()}
            
            {renderNote()}

          </section>
        )
      };
      
      if (this.props.bodyType.carType) {
        if (this.props.bodyType.carType.grade) {
          if (this.props.bodyType.carType.grade.variant) {
            if (this.props.bodyType.carType.grade.variant.vehicleCreditData && this.props.bodyType.carType.grade.variant.vehicleCreditData instanceof Array && 1 <= this.props.bodyType.carType.grade.variant.vehicleCreditData.length) {
              return (
                <div>
                  {this.props.bodyType.carType.grade.variant.vehicleCreditData.map((vehicleCreditData, index)=> {
                    return renderCreditDataInfo(vehicleCreditData, index);
                  })}
                </div>
              )
            }
          }
        }
      }
      return null;
    };
    
    // ナビゲーション表示
    const renderNavigation = ()=> {
      
      const getEstimationHeading = () => {
        if (this.props.estimationTitle && this.props.estimationTitle !== '') {
          return this.props.estimationTitle;
        } else {
          return null;
        }
      };
      const getMbEstimationHeading = () => {
        if (this.props.mbEstimationTitle && this.props.mbEstimationTitle !== '') {
          return this.props.mbEstimationTitle;
        } else {
          return getEstimationHeading();
        }
      };
  
      // 見積シミュレーションリンク表示
      const renderEstimationLink = ()=> {
        if (this.props.estimationLinkLabel && this.props.estimationLinkLabel !== '') {
          return (
            <div className="CreditPlan__navigation__estimation-link">
              <EstimateLink {...{
                label: this.props.estimationLinkLabel || '見積りシミュレーションする',
                targetBlank: false,
                color: 'Dark',
                buttonStyle: 'Action',
                linkType: 'Button',
                carId: this.props.bodyType.carId,
                carTypeCode: this.props.bodyType.carType.carTypeCode,
              }}/>
            </div>
          )
        } else {
          return null;
        }
      };
      
      const estimationHeading = getEstimationHeading();
      const mbEstimationHeading = getMbEstimationHeading();
  
      return (
        <div className="CreditPlan__navigation">
          {(estimationHeading !== null) ?
            <h6 className="CreditPlan__navigation__heading">
              <span className="CreditPlan__navigation__heading-pc" dangerouslySetInnerHTML={{__html: convertPipeToBrTag(estimationHeading)}}/>
              <span className="CreditPlan__navigation__heading-mb" dangerouslySetInnerHTML={{__html: convertPipeToBrTag(mbEstimationHeading)}}/>
            </h6>
            : null}
            
          {renderEstimationLink()}
          
          {(this.props.lowerInformation && this.props.lowerInformation !== '') ?
            <div className="CreditPlan__navigation__lower-information Wysiwyg" dangerouslySetInnerHTML={{__html: this.props.lowerInformation}}/>
            : null}
        </div>
      )
    };
    
    let tableStyle = null;
    if (this.props.tableColorSelector && this.props.tableColorSelector === 'Table-on-White') {
      tableStyle = ' tableOnWhite';
    } else if (this.props.tableColorSelector && this.props.tableColorSelector === 'Table-on-Gray') {
      tableStyle = ' tableOnGray';
    }
    
    return (
      <Wrapper
        containerId={this.props.containerId}
        containerClass={this.props.containerClass}
        anchorPoint={this.props.anchorPoint}
        anchorName={this.props.anchorName}
      >
        <div className={'CreditPlan' + ((tableStyle) ? tableStyle : '')}>
          <div className="CreditPlan__container">
            
            {renderHeader()}
            
            {renderCarInfo()}
            
            {renderCreditData()}
            
            {renderNavigation()}
            
          </div>
        </div>
      </Wrapper>
    )
  }
  
  // モーダルウィンドウ開く
  openModal = (ref) => {
    this.refs[ref].open('Light', 'Light');
    // BODYのスクロール無効化
    //BodyControl.openModal();
  };
  
  onCloseModal = () => {
    // BODYのスクロール無効化を解除
    //BodyControl.closeModal();
  };
  
  // 金額フォーマット
  formatPrice = (num) => {
    return '¥' + String(num).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
  };
  
}

export default CreditPlan;



// WEBPACK FOOTER //
// ./src/containers/credit-plan/index.jsx